export default "/static/build/norton-secured.png";